import { Directive, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';

@Directive({
  selector: '[extendedRouterLinkActive]',
})
export class ExtendedRouterLinkActiveDirective implements OnInit, OnDestroy {
  @Input() extendedRouterLink!: string;
  @Input() extendedRouterLinkActive!: string;

  private navigationEndSubscription!: Subscription;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private el: ElementRef,
  ) {}

  ngOnInit(): void {
    if (this.extendedRouterLinkActive && this.extendedRouterLink) {
      this.checkMatchLevel();

      const onNavigationEnd = this.router.events.pipe(
        filter((event) => event instanceof NavigationEnd),
      );
      this.navigationEndSubscription = onNavigationEnd.subscribe(() => {
        this.checkMatchLevel();
      });
    }
  }

  ngOnDestroy(): void {
    if (this.navigationEndSubscription) {
      this.navigationEndSubscription.unsubscribe();
    }
  }

  /** Check wich level on matching routerLink has the element */
  checkMatchLevel() {
    if (!this.extendedRouterLinkActive || !this.extendedRouterLink) {
      return;
    }
    //TODO: Better way to get routerLink value?
    const activeRoute = this.router.url.replace('/', '').split('/');
    const routerLink = this.extendedRouterLink.replace('/', '');

    let urlMatch: boolean = false;

    do {
      urlMatch = routerLink == activeRoute.join('/');

      if (!urlMatch) {
        activeRoute.splice(activeRoute.length - 1);
      } else {
        this.el.nativeElement.setAttribute(
          'data-router-link-level',
          activeRoute.length,
        );
      }
    } while (!urlMatch && activeRoute.length);

    if (!urlMatch) {
      this.el.nativeElement.removeAttribute('data-router-link-level');
    }

    this.hightlightMatchedItems();
  }

  /** Set routerLinkActive class to elemnt with highest matching level */
  hightlightMatchedItems() {
    const elements = Array.from(
      document.querySelectorAll('[extendedrouterlinkactive]'),
    );
    if (elements && elements.length != 0) {
      elements.forEach((element) => {
        element.classList.remove(this.extendedRouterLinkActive);
      });
      elements.sort((a, b) => {
        const aLevel = a.getAttribute('data-router-link-level') ?? '0';
        const bLevel = b.getAttribute('data-router-link-level') ?? '0';

        return parseInt(bLevel, 10) - parseInt(aLevel, 10);
      });

      elements[0].classList.add(this.extendedRouterLinkActive);
    }
  }
}
